import React from 'react';
import { Currency } from '../../../common/format';
import { ProjectionColumn, renderProjectionCell } from './projection-columns';

type RowKeyable = Record<string, number | undefined>;

interface ProjectionTableProps<TRow extends RowKeyable> {
  rows: TRow[];
  columns: ProjectionColumn<TRow>[];
  currency: Currency;
  ufValue: number;
  title?: string;
  maxHeight?: number;
  rowKey?: keyof TRow & string;
}

export function ProjectionTable<TRow extends RowKeyable>({
  rows,
  columns,
  currency,
  ufValue,
  title = 'Detalle anual',
  maxHeight = 480,
  rowKey = 'year',
}: ProjectionTableProps<TRow>) {
  return (
    <div className="card">
      <div className="card-header">
        <strong>{title}</strong>
      </div>
      <div className="table-responsive" style={{ maxHeight }}>
        <table className="table table-sm table-striped mb-0">
          <thead className="sticky-top bg-light">
            <tr>
              {columns.map((col) => (
                <th key={col.id} scope="col" className="small">{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={(row[rowKey] as number | undefined) ?? rowIndex}>
                {columns.map((col) => (
                  <td key={col.id} className="small">
                    {renderProjectionCell(row, col, currency, ufValue)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
